const services = [
  {
    image: 'https://public.readdy.ai/ai/img_res/9781cefa73d91ae05a7c16b2adabb5ea.jpg',
    title: '가정이사',
    desc: '아파트·단독주택 전문',
    link: '/service'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Korean%20moving%20worker%20carrying%20boxes%20out%20of%20a%20small%20studio%20apartment%20one%20room%2C%20single%20room%20with%20bed%20and%20desk%2C%20organized%20boxes%20labeled%2C%20professional%20mover%20in%20uniform%2C%20realistic%20photo%2C%20bright%20indoor%20lighting%2C%20clean%20and%20tidy%20space&width=400&height=300&seq=svc02&orientation=landscape',
    title: '원룸이사',
    desc: '빠르고 합리적인 이사',
    link: '/service'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=professional%20office%20relocation%20team%20moving%20office%20furniture%20desks%20computers%20monitors%20in%20a%20modern%20Korean%20office%20building%2C%20workers%20in%20uniform%20carefully%20wrapping%20equipment%2C%20bright%20office%20space%2C%20realistic%20photo%2C%20organized%20packing&width=400&height=300&seq=svc03&orientation=landscape',
    title: '사무실이사',
    desc: '사무실·빌딩 대형이사',
    link: '/office'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=clean%20organized%20Korean%20moving%20storage%20warehouse%20interior%2C%20cardboard%20boxes%20neatly%20stacked%20on%20metal%20shelves%2C%20labeled%20furniture%20wrapped%20in%20protective%20covers%2C%20bright%20warehouse%20lighting%2C%20professional%20storage%20facility%2C%20realistic%20photo&width=400&height=300&seq=svc04&orientation=landscape',
    title: '보관이사',
    desc: '단기·장기 안전 보관',
    link: '/service'
  }
];

export default function Services() {
  return (
    <section id="services" className="py-14 md:py-20 px-4 md:px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <span className="text-xs font-bold tracking-widest text-teal-600 uppercase">Our Services</span>
          <h2 className="mt-2 text-2xl md:text-4xl font-black text-gray-950">
            어떤 이사든 직영으로 합니다
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5">
          {services.map((service, index) => (
            <a
              key={index}
              href={service.link}
              className="group cursor-pointer rounded-xl overflow-hidden border border-gray-100 hover:border-teal-200 transition-all duration-300"
            >
              <div className="w-full h-32 md:h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-3 md:p-4 bg-white group-hover:bg-teal-50 transition-colors duration-300">
                <h3 className="text-sm md:text-base font-bold text-gray-950 group-hover:text-teal-700 transition-colors mb-0.5 md:mb-1">
                  {service.title}
                </h3>
                <p className="text-xs text-gray-500 group-hover:text-teal-600 transition-colors">
                  {service.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
